module.exports = __webpack_public_path__ + "img/plus.bc77bc74.svg";